export class HttpError extends Error {



    /**
     *
     * @param {string} message
     */
    constructor(message: string) {
        super(message);
        this.name = "HttpError";
    }
}